import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";

import Footer from "@/components/footer.vue";

Vue.config.productionTip = false;
Vue.component("Footer", Footer);

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
